@if (!editMode) {
  <div>
    <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:mb-2">
      <div class="tw:w-full tw:px-[15px] tw:lg:w-1/2 tw:mb-12">
        <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:my-2">
          <div class="tw:w-auto tw:px-[15px]">
            <div class="kvp__k">Learner's Current Target:</div>
            <div class="kvp__k">Learner's Current Assessment Target:</div>
          </div>
          <div class="tw:flex-1 tw:px-[15px]">
            <div class="kvp__v">{{ timelineSection.currentTarget}}&nbsp;</div>
            <div class="kvp__v">{{ timelineSection.assessmentTarget}} % &nbsp;</div>
          </div>
        </div>
      </div>
      <div class="tw:w-full tw:px-[15px] tw:lg:w-1/2">
        <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:mb-2">
          <div class="tw:flex-1 tw:px-[15px]">
            <div class="kvp kvp--stacked">
              <div class="kvp__k kvp__k--heading">Target Comments:</div>
              <div class="kvp__v kvp__v--long-text">
                {{ timelineSection.targetComments }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}

@if (editMode) {
  <div>
    <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:mb-12">
      <div class="tw:w-1/2 tw:px-[15px]">
        <label class="field__label">Target Type:</label>
        <select class="field__control" [(ngModel)]="timelineSection.targetType"
          name="currentTarget"
          [disabled]="!isFormEditable()">
          @for (targetType of targetTypeList; track targetType) {
            <option [ngValue]="targetType.text">{{ targetType.text }}</option>
          }
        </select>
      </div>
    </div>
    @if (currentTargetVisible()) {
      <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:mb-12">
        <div class="tw:flex-1 tw:px-[15px]">
          <label class="field__label">Learners Current Target:</label>
          <select class="field__control" [(ngModel)]="timelineSection.currentTarget"
            name="currentTarget"
            [disabled]="!isFormEditable()">
            @for (target of targetList; track target) {
              <option [ngValue]="target.text">{{ target.text }}</option>
            }
          </select>
        </div>
        <div class="tw:w-1/2 tw:px-[15px]">
          {{ learnerJourneyDescription() }}
        </div>
      </div>
    }
    @if (assessmentTargetVisible()) {
      <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:mb-12">
        <div class="tw:w-full tw:px-[15px] tw:lg:w-1/2">
          <label class="field__label">Learner's Current Assessment Target:</label>
          <div class="tw:flex tw:items-center">
            <input class="field__control tw:w-1/4"
              type="text"
              [(ngModel)]="timelineSection.assessmentTarget"
              name="currentTargetAssessment"
              [disabled]="!isFormEditable()" />
            <span class="tw:ml-2">%</span>
          </div>
          </div>
        </div>
      }
      <div class="tw:flex tw:flex-wrap tw:-mx-[15px]">
        <div class="tw:flex-1 tw:px-[15px]">
          <label class="field__label">Target Comments:</label>
          <textarea class="field__control"
            [(ngModel)]="timelineSection.targetComments"
            name="comments"
            rows="7"
            maxlength="3000"
            [disabled]="!isFormEditable()"></textarea>
          <span class="field__hint tw:block tw:text-right">{{timelineSection.targetComments?.length || 0}}/3000</span>
        </div>
      </div>
    </div>
  }
